import {
  Component,
  OnInit,
} from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from "../../services/data.service"
import { InPurchasesService, } from "../../../shared/services/inventory/in-purchases.service";
import { DatePipe } from '@angular/common';
import { forEach } from "@angular/router/src/utils/collection";
import { environment } from "../../../../environments/environment";
import { DecimalPipe } from '@angular/common';

export interface AddChargeItems {
  title: string;
  amount: number;
  data: any;
}

@Component({
  selector: 'app-addcharge-popup',
  templateUrl: './addcharge-popup.component.html',
  styleUrls: ['./addcharge-popup.component.css']
})

export class AddChargePopUpComponent extends DialogComponent<AddChargeItems, boolean>
  implements AddChargeItems, OnInit {

  title: string;
  data: any;
  amount: number;

  result: any = { result: false, RtnItem: [] };
  addChargeList: AddCharge_Master[] = [];
  loading: boolean = false;

  constructor(dialogService: DialogService, private ds: DataService, public datepipe: DatePipe,
    private ips: InPurchasesService) {
    super(dialogService);
  }
  ngOnChanges() {

  }
  ngOnInit() {
    this.clear();
    this.addChargeList = this.data;
    if (this.addChargeList.length == 0) {
      this.getadBillCharges();
    }
  }

  ok() {
    this.result.result = true;
    this.result.RtnItem = this.addChargeList;
    this.close();
  }

  clear() {
    this.loading = false;
  }

  getadBillCharges() {
    this.loading = true;
    this.ips.Get_AddBillCharges().subscribe(res => {
      if (res.Success) {
        this.addChargeList = res.data;
        for (let i of this.addChargeList) {
          if (i.FedAs == 0) {
            i.FedValue = i.FedValue
          }
          else if (i.FedAs == 1) {
            i.FedValue = ((Number(this.amount) * Number(i.FedValue)) / 100)
          }
          else {
            i.FedValue = 0
          }
          i.FedValue = Number(parseFloat(i.FedValue.toString()).toFixed(environment.noofdecimal))
          if (i.LedgerId == 0) {
            i.LedgerId = i.SqlDataList[0].Id;
          }
        }

        this.loading = false;
      }
      else {
        this.addChargeList = [];
        this.loading = false;
      }
    });
  }

}

class AddCharge_Master {
  Id: number
  Name: string
  VchrType: number
  ControlType: number
  LedgerId: number
  FedAs: number
  FedValue: number
  SqlQuery: string
  SqlDataList: Ledger_addcharge[]
}
class Ledger_addcharge {
  Name: string = ""
  ledgerid: number = 0
  Id: number = 0
}






// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/addcharge-popup/addcharge-popup.component.ts